import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_6141d8b1: FaireBrandEntity = {
  token: "b_6141d8b1",
  type: "brand",
  name: "Quotable",
  avatarUrl:
    "https://cdn.faire.com/fastly/6db63a1dac595f482e527b2f8eeca092807f2e7fdb3d235b4e007f22dfc5edcd.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/4f7f32ee0c53c353dab55066d4adf365eb4dacbf9f5753929897637099aa9aa4.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/6db63a1dac595f482e527b2f8eeca092807f2e7fdb3d235b4e007f22dfc5edcd.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/4f7f32ee0c53c353dab55066d4adf365eb4dacbf9f5753929897637099aa9aa4.jpeg",
  location: "New York, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 115,
  isTopShop: true,
  isInsider: true,
  description:
    "Hi!\nWe’re Quotable.\n\nOur cards and gifts start with words that matter and iconic design. They’re meant to be shared, held onto, and returned to. When meaning feels harder to come by, we’re here with something real.\n\nOur collection works across all kinds of stores and covers the most universal moments. They’re the pieces people reach for when they want something that just feels right.\nThank you for being a part of our mission to spread the words.\n",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:50:56.750Z",
    importedBy: "entity-db-cli",
  },
};
